export default __webpack_public_path__ + "static/media/segundologincodigo.e608f993.svg";